module.exports = __webpack_public_path__ + "img/symbol_8.bc714628.png";